import(/* webpackMode: "eager", webpackExports: ["StakingProjectClient"] */ "/codebuild/output/src695705932/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/staking/[id]/StakingProjectClient.tsx");
